//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Index',
  components: {
    explain: function explain() {
      return import('./components/explain');
    },
    process: function process() {
      return import('./components/process');
    },
    plan: function plan() {
      return import('./components/plan');
    }
  },
  data: function data() {
    return {
      totalPage: 0,
      tableData: [],
      tabCur: 0
    };
  },
  created: function created() {
    if (this.$route.path == "".concat(roterPre, "/hr/staff/config/assessmentPlan")) {
      this.tabCur = 0;
    } else if (this.$route.path == "".concat(roterPre, "/hr/staff/config/assessmentScore")) {
      this.tabCur = 1;
    } else {
      this.tabCur = 2;
    }
  },
  mounted: function mounted() {},
  methods: {
    handleClick: function handleClick(number) {
      this.tabCur = number.index;
    }
  }
};